import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EnvironmentService} from '@core/environment/environment.service';
import {ConsentUseCaseModel} from './response/consent-use-case.module';
import {ConsentUseCaseBasicModel} from './response/consent-use-case-basic.model';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {LanguageEnum} from '@core/enums/language.enum';

@Injectable()
export class ConsentUseCaseRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/usecase';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getConsentUseCases(indicationId: string, language: LanguageEnum, languageStyle: LanguageStyleEnum): Observable<ConsentUseCaseBasicModel[]> {
        return this.httpClient.get<ConsentUseCaseBasicModel[]>(this.controllerUrl + `/indication/${indicationId}/${language}/${languageStyle}`);
    }

    getConsentUseCase(consentUseCaseId: string): Observable<ConsentUseCaseModel> {
        return this.httpClient.get<ConsentUseCaseModel>(this.controllerUrl + `/${consentUseCaseId}`);
    }

    getConsentUseCaseDuration(consentUseCaseId: string): Observable<ConsentUseCaseModel> {
        return this.httpClient.get<ConsentUseCaseModel>(this.controllerUrl + `/${consentUseCaseId}`);
    }
}
